<template>
  <div class="Others28Charts" :class="getStyle('Style')"></div>
</template>

<script>
import { request } from '../../../common/request';
export default {
  name: 'Others28Charts',
  props: {
    ProjectInfo: Object,
    Configuration: Object,
    ComboBoxCharts: Object,
  },
  computed: {
    style() {
      return this.ProjectInfo.Style.componentName;
    },
  },
  data() {
    return {
      debounce_subscribeConfigurationChange: null, // 订阅Configuration变化的防抖函数
      apiIntervalTaskID: null, // api任务的定时器ID
      staticIntervalTaskID: null, // 静态任务的定时器ID

      noData: false, // 是否没有数据
      fontStyle: {},
      dataSet: {
        seriesList: [],
        source: [],
      },

      maxValue: 500,
    };
  },
  created() {
    this.registerDebounceAndThrottle();
  },
  mounted() {
    this.startApiIntervalTask();
    this.startStaticIntervalTask();
  },
  methods: {
    getStyle(e = '') {
      let style = {};
      switch (this.style) {
        case 'V1Style':
          style['V1' + e] = true;
          break;
        case 'V2Style':
          style['V2' + e] = true;
          break;
        case 'V3Style':
          style['V3' + e] = true;
          break;
        case 'V4Style':
          style['V4' + e] = true;
          break;
        case 'V5Style':
          style['V5' + e] = true;
          break;
        case 'V14Style':
          style['V14' + e] = true;
          break;
        default:
          break;
      }
      return style;
    },

    getShowfontSizeBase() {
      return Math.round(this.Configuration.style.height / 20);
    },
    registerDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      clearTimeout(this.apiIntervalTaskID);
      clearTimeout(this.staticIntervalTaskID);
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    },

    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      // 清除之前的 interval 任务（如果有的话）
      clearTimeout(this.apiIntervalTaskID);

      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      console.log('startApiIntervalTask:>>>>', ChartsData?.apiData?.isUseInterval);

      if (ChartsData?.currenEntry !== 'apiData') return;

      this.getApiDataResByFilterAndResponseQuery()
        .then(this.setEchartsOptions)
        .catch(err =>
          console.log('startApiIntervalTask-getApiDataResByFilterAndResponseQuery failed:>>>>', err),
        )
        .finally(() => {
          if (ChartsData?.apiData?.isUseInterval) {
            console.log('开启 interval 任务，间隔请求');
            this.apiIntervalTaskID = setTimeout(
              () => this.startApiIntervalTask(),
              ChartsData?.apiData?.apiInterval * 1000,
            );
          }
        });
    },
    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;

      if (ChartsData?.currenEntry !== 'staticData') return;

      if (chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let data = this.$_.cloneDeep(ChartsData.staticData);
        data.source.forEach(item => (item.y = 0));
        this.setEchartsOptions(data);
        setTimeout(() => this.setEchartsOptions(this.$_.cloneDeep(ChartsData.staticData)), 0);

        this.staticIntervalTaskID = setTimeout(
          () => this.startStaticIntervalTask(),
          chartsAnimation?.staticRefreshIntervalTime * 1000,
        );
      } else {
        console.log('无静态任务 执行staticData');
        this.setEchartsOptions(ChartsData.staticData);
      }
    },
    // promise 返回api链接的请求数据 使用ResponseQuery和过滤器函数
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');

        this.getApiDataRes()
          .then(res => {
            // query数据
            let keys = ChartsData.apiData.apiResponseQuery.split('.');
            if (keys.length) {
              console.log('keys:>>>>', keys);
              keys.forEach(key => (res = res[key]));
            }

            let result = null;

            // 判断是否使用过滤器
            if (ChartsData.apiData.isUseFilter) {
              result = this.run_script(ChartsData.apiData.apiFilter, res);
            } else {
              result = res;
            }

            resolve(result);
          })
          .catch(reject);
      });
    },
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;

      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');

        let param = {
          method: ChartsData.apiData.apiUrlMethod,
          url: ChartsData.apiData.apiUrl,
          params: {},
        };

        if (ChartsData.apiData?.isUseUserKey) {
          let user_key = localStorage.getItem('user_key');
          if (user_key == 'undefined' || user_key == 'null' || user_key == null) user_key = this.$userKey;
          param['headers'] = { userkey: user_key };
        }

        request(param).then(resolve).catch(reject);
      });
    },

    setEchartsOptions(data = null) {
      this.fontStyle = {};
      let fontStyle = {
        titleColor: '#ccc',
        titleSize: 16,
        xAxisColor: '#c3dbff',
        xAxisSize: 12,
        yAxisColor: '#c3dbff',
        yAxisSize: 12,
      };

      if (this.Configuration.propertyData.fontStyle.value) {
        this.fontStyle = this.Configuration.propertyData.fontStyle.value;
      }

      if (!data) return (this.noData = true);
      this.dataSet = data;
      this.maxValue = this.dataSet.source.reduce((max, item) => (item.y > max ? item.y : max), 0);
    },

    /**
     * 运行脚本
     * @param {string} script 脚本
     * @param {*} data 数据
     */
    run_script(script, data) {
      let dataSet = {};
      try {
        eval(script);
      } catch (error) {
        console.error('run_script failed: ', error);
      }
      return dataSet;
    },
  },
  beforeUnmount() {
    clearTimeout(this.apiIntervalTaskID);
    clearTimeout(this.staticIntervalTaskID);
    this.unRegisterDebounceAndThrottle();
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function () {
        if (this.Configuration.isScaling) {
          console.log('scale');
        } else if (this.Configuration.isMoving) {
          console.log('mov');
        } else {
          this.debounce_subscribeConfigurationChange();
        }
      },
    },
  },
  Configuration: {
    componentTitle: '背景组件',
    componentName: 'Others28Charts',
    componentOverViewImg: './img/charts/OthersCharts/Others28Charts.png',
    id: '',
    style: {
      width: 462,
      height: 194,
      left: 0,
      top: 0,
    },
    isScaling: false,
    isMoving: false,
    propertyData: {
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },

      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      chartsColor: {
        propertyComponentName: 'ArrayColorSelector',
        value: {
          chartColor: [
            'rgba(223,65,56,1)',
            'rgba(229,115,63,1)',
            'rgba(240,189,108,1)',
            'rgba(237,214,102,1)',
            'rgba(77,168,222,1)',
            'rgba(25,168,164,1)',
          ],
          chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
        },
      },

      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 300,
          height: 80,
          left: 0,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
          xAxisSize: 14,
          xAxisColor: '#fff',
          yAxisSize: 14,
          yAxisColor: '#fff',
        },
      },
      chartsGrid: {
        lable: '图表定位',
        propertyComponentName: 'ChartsGridConfiger',
        value: {
          left: '5%',
          right: '10%',
          bottom: '0%',
          top: '0%',
        },
      },
      showStatus: {
        value: 'norm',
      },
      chartsOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
      textComponentUnits: {
        propertyComponentName: 'MapTextConfiger',
        value: '元',
      },
      chartsAnimation: {
        propertyComponentName: 'ChartsAnimationConfiger',
        value: {
          isUseAnimation: false,
          isUseStaticRefresh: false,
          staticRefreshIntervalTime: 5,
        },
      },
    },
  },
};
</script>

<style scoped lang="scss">
.Others28Charts {
  width: 100%;
  height: 100%;
}

.V14Style {
  background: url('../../../assets/img/style14bg.png') no-repeat;
  background-size: contain;
  background-position: center;
  background-size: 100% 100%;
}
</style>
